


export const CONTACTDATA = `/api/api/contact/{id}`
export const WORKDATA = `/api/api/work/{id}`
export const EDUCATIONDATA = `/api/api/education/{id}`
export const SKILLSDATA = `/api/api/skills/{id}`
export const PROJECTSDATA = `/api/api/projects/{id}`
export const ABOUTTEXT = `/api/api/about/{id}`
